export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Harika!', 'Mükemmel', 'Süper!']
export const GAME_COPIED_MESSAGE = 'Oyun kopyalandı'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Yeterli harf yok'
export const WORD_NOT_FOUND_MESSAGE = 'Kelime bulunamadı'
export const HARD_MODE_ALERT_MESSAGE =
  'Hard Mode can be enabled only at the start!'
export const HARD_MODE_DESCRIPTION =
  'Any revealed hints must be used in subsequent guesses'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `kelime ${solution} idi`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Tahmin ${guess} şu pozisyonda olmalı ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Guess must contain ${letter}`
export const ENTER_TEXT = 'Tahmin'
export const DELETE_TEXT = 'Sil'
export const STATISTICS_TITLE = 'İstatistikler'
export const GUESS_DISTRIBUTION_TEXT = 'Tahmin Dağılımı'
export const NEW_WORD_TEXT = 'Yeni kelime'
export const SHARE_TEXT = 'Paylaş'
export const SHARE_FAILURE_TEXT =
  'Paylaşım yapılamadı!'
export const MIGRATE_BUTTON_TEXT = 'Transfer'
export const MIGRATE_DESCRIPTION_TEXT =
  'İstatistiklerinizi transfer edin'
export const TOTAL_TRIES_TEXT = 'Deneme'
export const SUCCESS_RATE_TEXT = 'Başarı Oranı'
export const CURRENT_STREAK_TEXT = 'Mevcut Seri'
export const BEST_STREAK_TEXT = 'En İyi Seri'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  "You are using an embedded browser and may experience problems sharing or saving your results. We encourage you rather to use your device's default browser."

export const DATEPICKER_TITLE = 'Choose a past date'
export const DATEPICKER_CHOOSE_TEXT = 'Choose'
export const DATEPICKER_TODAY_TEXT = 'today'
export const ARCHIVE_GAMEDATE_TEXT = 'Game date'
